import React from 'react';
import PropTypes from 'prop-types';

import { Link } from "react-router-dom";

import Card from '@material-ui/core/Card'
import Button from '@material-ui/core/Button'

const About = (props) => {
  return (
    <div style={{'padding':8, 'margin': 8}}>
    <Card style={{'padding':8, 'margin': 8}}>
      <h2>About</h2>
      <p>
        Bacon ipsum dolor amet tail landjaeger corned beef chuck hamburger,
        salami strip steak. Pancetta kielbasa ham hock andouille. Tail cupim
        burgdoggen salami bacon jerky shankle strip steak turkey. Drumstick
        shoulder pork loin, filet mignon cupim alcatra tongue jowl. Cupim
        tenderloin rump t-bone. Picanha turducken short loin jowl, landjaeger
        shoulder t-bone buffalo spare ribs salami pastrami tri-tip ground round
        alcatra.
      </p>
      <Button onClick={() => props.history.goBack()} >Back</Button>
      </Card>
      </div>
  );
};

// About.PropTypes = {

// }

export default About;